import { toApiStatus, toStatus } from '@/api/mappers/mapStatus';
import {
  User as ApiUser,
  UserCreateRequest as ApiUserCreateRequest,
  UserUpdateRequest as ApiUserUpdateRequest,
} from '@/gen/api';
import { User as UserModel, UserRole } from '@/models/User';

const parseUserRole = (roleString: string): UserRole => {
  switch (roleString.toUpperCase()) {
    case 'SYSTEM_ADMIN':
      return UserRole.SystemAdmin;
    case 'RETAILER_ADMIN':
      return UserRole.RetailerAdmin;
    case 'SUPPLIER_ADMIN':
      return UserRole.SupplierAdmin;
    case 'STORE_MANAGER':
      return UserRole.StoreManager;
    default:
      return UserRole.Unknown;
  }
};

export const toUser = (apiUser: ApiUser): UserModel => {
  return {
    ...apiUser,
    role: parseUserRole(apiUser.role),
    status: toStatus(apiUser.status),
  };
};

export const toApiUserCreate = (user: UserModel): ApiUserCreateRequest => {
  return {
    ...user,
    status: toApiStatus(user.status),
    password: user.password || '',
    organizationId: user.organizationId || '',
  };
};

export const toApiUserUpdate = (user: UserModel): ApiUserUpdateRequest => {
  return {
    ...user,
    status: toApiStatus(user.status),
  };
};
